import { render, staticRenderFns } from "./PluginMetaBuyButton.vue?vue&type=template&id=74bd5a02"
import script from "./PluginMetaBuyButton.vue?vue&type=script&lang=js"
export * from "./PluginMetaBuyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports